var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5026,
    cy: 11.641,
    r: 11.641,
    fill: "#1D1D1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18128 10.7556C9.09202 10.7556 9.83033 10.0157 9.83033 9.1029C9.83033 8.19014 9.09202 7.4502 8.18128 7.4502C7.27053 7.4502 6.53223 8.19014 6.53223 9.1029C6.53223 10.0157 7.27053 10.7556 8.18128 10.7556Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.408 10.7556C13.3187 10.7556 14.057 10.0157 14.057 9.1029C14.057 8.19014 13.3187 7.4502 12.408 7.4502C11.4972 7.4502 10.7589 8.19014 10.7589 9.1029C10.7589 10.0157 11.4972 10.7556 12.408 10.7556Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.324 10.7556C17.2347 10.7556 17.973 10.0157 17.973 9.1029C17.973 8.19014 17.2347 7.4502 16.324 7.4502C15.4132 7.4502 14.6749 8.19014 14.6749 9.1029C14.6749 10.0157 15.4132 10.7556 16.324 10.7556Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44922 13.1957C6.44922 12.2829 7.18755 11.543 8.09827 11.543H8.26252C9.17324 11.543 9.91158 12.2829 9.91158 13.1957V14.9005H6.44922V13.1957Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.592 13.1957C14.592 12.2829 15.3304 11.543 16.2411 11.543H16.4053C17.3161 11.543 18.0544 12.2829 18.0544 13.1957V14.9005H14.592V13.1957Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6759 13.1957C10.6759 12.2829 11.4142 11.543 12.325 11.543H12.4892C13.3999 11.543 14.1383 12.2829 14.1383 13.1957V14.9005H10.6759V13.1957Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyUser);
export default __webpack_public_path__ + "static/media/empty-user.025824e2cce49c4b7432bf321e86bbc0.svg";
export { ForwardRef as ReactComponent };